class BenefitGrid extends HTMLElement {
    connectedCallback() {
        this.items = this.querySelectorAll('.bennefits-items-sticky');
        this.setLeftPosition();
        window.addEventListener('resize', this.setLeftPosition.bind(this));
    }

    setWidthOverlay() {
        const firstElementColumn = this.items[0].querySelector('.bennefits-name');
        const widthFirstElement = firstElementColumn.getBoundingClientRect().width;
        const widthNextSibling = this.items[0].querySelector('.benefits-heading-item').getBoundingClientRect().width;
        const widthOverlay = widthFirstElement + widthNextSibling;
        this.closest('.section-benefits-body-grid').style.setProperty('--width-overlay', `${widthOverlay}px`);
    }
    setLeftPosition() {
        this.setWidthOverlay();
        this.items.forEach(item => {
            const firstElementColumn = item.querySelector('.bennefits-name');
            const rect = firstElementColumn.getBoundingClientRect();
            const exactWidth = rect.width;
            firstElementColumn.nextElementSibling.style.setProperty('--left', `${exactWidth}px`)
        });
    }

}

customElements.define('benefit-grid', BenefitGrid);